// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMethods-module__container___3h2hk","title":"PaymentMethods-module__title___19Yjo","content":"PaymentMethods-module__content___3DwJb"};